import { render } from "./SpaceBuilder.vue?vue&type=template&id=248c4b27"
import script from "./SpaceBuilder.vue?vue&type=script&lang=js"
export * from "./SpaceBuilder.vue?vue&type=script&lang=js"

import "./SpaceBuilder.vue?vue&type=style&index=0&id=248c4b27&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__